import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import '../App.css';

const SignupAppointmentUI = ({
  courses,
  selectedCourse,
  setSelectedCourse,
  handleSubmit,
  disable,
  setDate,
  date,
  time,
  setTime,
}) => {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card
            style={{
              boxShadow: '0 4px 12px rgba(0, 128, 0, 0.2)',
              borderRadius: '16px',
              overflow: 'hidden',
            }}
          >
            <Card.Header
              className="bg-success text-white"
              style={{
                padding: '1.2rem 1.5rem',
                borderBottom: 'none',
                textAlign: 'center',
              }}
            >
              <h4 style={{ margin: 0, fontWeight: 600 }}>Set Appointment Form</h4>
            </Card.Header>

            <Form.Label
              style={{
                fontSize: '1.1rem',
                textAlign: 'center',
                display: 'block',
                margin: '20px auto',
                fontWeight: 500,
                color: '#333',
              }}
            >
              Select the appointment you would like to make
            </Form.Label>

            <Card.Body style={{ padding: '1rem 2rem' }}>
              <Form style={{ width: '100%' }}>
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Select a course</Form.Label>
                      {courses.map((course) => (
                        <Form.Check
                          type="radio"
                          key={course.id}
                          label={`${course.subject} - ${course.abbreviatedName}`}
                          name="course"
                          value={course.id}
                          checked={selectedCourse ? selectedCourse.id === course.id : false}
                          onChange={() => setSelectedCourse(course)}
                          style={{
                            marginBottom: '1rem',
                            paddingLeft: '1.25rem',
                            fontSize: '1rem',
                            fontWeight: 500,
                            color: '#333',
                          }}
                        />
                      ))}
                    </Form.Group>
                  </Col>

                  {selectedCourse && (
                    <Col md={6}>
                      <div
                        style={{
                          border: '2px solid var--(PRIMARY-COLOR)',
                          borderRadius: '12px',
                          padding: '1.5rem',
                          backgroundColor: 'var--(PRIMARY-COLOR)',
                        }}
                      >
                        <h6 style={{ fontWeight: 500, margin: '0.5rem 0' }}>
                          Course Name: {selectedCourse.subject}
                        </h6>
                        <h6 style={{ fontWeight: 500, margin: '0.5rem 0' }}>
                          Course Num: {selectedCourse.abbreviatedName}
                        </h6>

                        <Form.Group style={{ margin: '0.5rem 0' }}>
                          <Form.Label>Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                          />
                        </Form.Group>

                        <Form.Group style={{ margin: '0.5rem 0' }}>
                          <Form.Label>Time</Form.Label>
                          <Form.Select value={time} onChange={(e) => setTime(e.target.value)}>
                            <option value="">Select Time</option>
                            <option value="7:30 AM">7:30 AM</option>
                            <option value="8:00 AM">8:00 AM</option>
                            <option value="8:30 AM">8:30 AM</option>
                            <option value="9:00 AM">9:00 AM</option>
                            <option value="9:30 AM">9:30 AM</option>
                            <option value="10:00 AM">10:00 AM</option>
                            <option value="10:30 AM">10:30 AM</option>
                            <option value="11:00 AM">11:00 AM</option>
                            <option value="11:30 AM">11:30 AM</option>
                            <option value="12:00 PM">12:00 PM</option>
                            <option value="12:30 PM">12:30 PM</option>
                            <option value="1:00 PM">1:00 PM</option>
                            <option value="1:30 PM">1:30 PM</option>
                            <option value="2:00 PM">2:00 PM</option>
                            <option value="2:30 PM">2:30 PM</option>
                            <option value="3:00 PM">3:00 PM</option>
                            <option value="3:30 PM">3:30 PM</option>
                            <option value="4:00 PM">4:00 PM</option>
                            <option value="4:30 PM">4:30 PM</option>
                            <option value="5:00 PM">5:00 PM</option>
                            <option value="5:30 PM">5:30 PM</option>
                            <option value="6:00 PM">6:00 PM</option>
                            <option value="6:30 PM">6:30 PM</option>
                            <option value="7:00 PM">7:00 PM</option>
                            <option value="7:30 PM">7:30 PM</option>
                            <option value="8:00 PM">8:00 PM</option>
                            <option value="8:30 PM">8:30 PM</option>
                            <option value="9:00 PM">9:00 PM</option>
                          </Form.Select>
                        </Form.Group>

                        <Form.Group style={{ margin: '0.5rem 0' }}>
                          <Form.Label>Proctor</Form.Label>
                          <Form.Control disabled type="text" placeholder="TBA" />
                        </Form.Group>
                      </div>
                    </Col>
                  )}
                </Row>

                <Button
                  variant="custom"
                  block="true"
                  onClick={handleSubmit}
                  disabled={disable}
                  style={{
                    backgroundColor: 'var--(PRIMARY-COLOR)',
                    color: 'white',
                    fontWeight: 600,
                    width: '100%',
                    marginTop: '1.5rem',
                  }}
                >
                  Schedule
                </Button>

                <Link
                  to="/studentdashboard"
                  className="btn btn-secondary btn-block mt-2"
                  style={{ width: '100%', height: '2.3rem' }}
                >
                  Back
                </Link>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SignupAppointmentUI;
